var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons",class:{
    'icon--left': _vm.left,
    'icon--right': _vm.right
  }},[_vm._t("default",function(){return [_vm._v("credit_card")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }